import type { ListTableColumn } from './types'

/** Maps a column's width (string | number | undefined) to sx props for the list table. */
export function widthSx(width: ListTableColumn['width']): { width?: string | number; maxWidth?: string | number } {
  if (typeof width === 'number') return { width, maxWidth: width }
  if (width && width !== 'auto') return { width }
  return {}
}
